"use client";

import type { IconProp } from "@fortawesome/fontawesome-svg-core";
import type {
	Aggregation,
	AggregationOption,
} from "~/app/[lang]/(default)/category/[id]/ProductsGrid";
import { StyledLink } from "~/components/Link";
import { useQuery } from "~/hooks/useQuery";
import { FILTER_SEPARATOR } from "../useFilterOption";

interface Props {
	title: string;
	icon: IconProp;
	aggregation: Aggregation;
	options: AggregationOption[];
	query: Record<string, string>;
}

export function FastFilterButton({ title, icon, aggregation, options, query }: Props) {
	const { createUrl } = useQuery();

	const queryParams = options
		.map((option) => option?.value)
		.filter(Boolean)
		.join(FILTER_SEPARATOR);

	return (
		<StyledLink
			href={`${createUrl({ [aggregation.attribute_code]: queryParams, ...query })}#products`}
			className="shrink-0 snap-start self-center"
			variant="outlined"
			starticon={icon}
		>
			{title}
		</StyledLink>
	);
}
